// Horizontal media gallery for the Kalü purchase section.
// - Mobile : native horizontal scroll + snap (swipe).
// - Desktop : prev/next arrows that scroll one slide at a time.
//   Arrows disable themselves at the start / end of the track.

if (!customElements.get('kalu-gallery')) {
  class KaluGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-gallery-track]');
      if (!this.track) return;

      this.prevBtn = this.querySelector('[data-gallery-prev]');
      this.nextBtn = this.querySelector('[data-gallery-next]');

      this.onPrev = () => this.scrollBySlide(-1);
      this.onNext = () => this.scrollBySlide(1);
      this.onScroll = () => this.updateArrows();

      if (this.prevBtn) this.prevBtn.addEventListener('click', this.onPrev);
      if (this.nextBtn) this.nextBtn.addEventListener('click', this.onNext);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });

      this.updateArrows();
    }

    disconnectedCallback() {
      if (this.prevBtn) this.prevBtn.removeEventListener('click', this.onPrev);
      if (this.nextBtn) this.nextBtn.removeEventListener('click', this.onNext);
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    scrollBySlide(direction) {
      const slide = this.track.querySelector('.kalu-purchase__gallery-slide');
      if (!slide) return;
      this.track.scrollBy({ left: slide.offsetWidth * direction, behavior: 'smooth' });
    }

    updateArrows() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const x = this.track.scrollLeft;
      if (this.prevBtn) this.prevBtn.disabled = x <= 2;
      if (this.nextBtn) this.nextBtn.disabled = x >= maxScroll - 2;
    }
  }

  customElements.define('kalu-gallery', KaluGallery);
}
